if ( ! window.BackInStockForm ) {

	window.BackInStockForm = {
		_prefix: window.KT_PREFIX || '',
		_klaviyoRevision: '2024-10-15',
		_klaviyoCatalogId: '$default',

		init() {
			document.addEventListener('submit', this._onSubmit.bind(this), true);
		},

		_getModalCommon() {
			return document.getElementById('modal-common');
		},

		_onSubmit(e) {
			const form = e.target.closest('.back-in-stock-form');
			if ( ! form ) {
				return;
			}

			e.preventDefault();
			e.stopPropagation();

			const modalCommon = this._getModalCommon();
			if ( ! modalCommon || ! modalCommon.contains(form) ) {
				return;
			}

			this._submitForm(form);
		},

		_showSuccess(form) {
			const success = form.querySelector('[data-js-back-in-stock-success]');
			const fields = form.querySelector('[data-js-back-in-stock-fields]');

			if ( success && fields ) {
				fields.hidden = true;
				success.hidden = false;
			}
		},

		_showError(form, message) {
			const errorContainer = form.querySelector('[data-js-back-in-stock-errors]');
			if ( ! errorContainer ) {
				return;
			}
			errorContainer.innerHTML = `<span class="alert alert--error alert--icon"><span>${message}</span></span>`;
		},

		_getGenericErrorMessage() {
			return window.KROWN?.settings?.locales?.cart_general_error || 'Something went wrong. Please try again.';
		},

		_buildVariantId(variantId, catalogId) {
			return `$shopify:::${catalogId}:::${variantId}`;
		},

		_buildPayload(email, variantId, catalogId) {
			return {
				data: {
					type: 'back-in-stock-subscription',
					attributes: {
						profile: {
							data: {
								type: 'profile',
								attributes: {
									email
								}
							}
						},
						channels: ['EMAIL']
					},
					relationships: {
						variant: {
							data: {
								type: 'catalog-variant',
								id: this._buildVariantId(variantId, catalogId)
							}
						}
					}
				}
			};
		},

		_buildProfilePayload(email, form) {
			const locale = form.dataset.locale;
			const localeLanguage = form.dataset.localeLanguage;
			const localeCountry = form.dataset.localeCountry;
			const market = form.dataset.market;
			const properties = {};

			if ( locale ) {
				properties.$locale = locale;
			}
			if ( localeLanguage ) {
				properties.$locale_language = localeLanguage;
			}
			if ( localeCountry ) {
				properties.$locale_country = localeCountry;
			}
			if ( market ) {
				properties.Shopify_Market = market;
			}

			const attributes = { email };
			if ( locale ) {
				attributes.locale = locale;
			}
			if ( Object.keys(properties).length ) {
				attributes.properties = properties;
			}

			return {
				data: {
					type: 'profile',
					attributes
				}
			};
		},

		async _updateProfileLocale(email, form, publicKey) {
			if ( ! form.dataset.locale ) {
				return true;
			}

			const url = `https://a.klaviyo.com/client/profiles/?company_id=${encodeURIComponent(publicKey)}`;
			const response = await fetch(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					revision: this._klaviyoRevision
				},
				body: JSON.stringify(this._buildProfilePayload(email, form))
			});

			return response.status === 202;
		},

		_parseKlaviyoError(data, response) {
			if ( data?.errors?.length ) {
				const first = data.errors[0];
				return (first.detail || first.title || '').trim();
			}
			return response.statusText || this._getGenericErrorMessage();
		},

		async _submitForm(form) {
			const submitButton = form.querySelector('[type="submit"]');
			const emailInput = form.querySelector('[name="email"]');
			const publicKey = form.dataset.klaviyoCompanyId;
			const variantId = form.dataset.variantId;
			const catalogId = this._klaviyoCatalogId;
			const revision = this._klaviyoRevision;

			if ( ! submitButton || ! emailInput ) {
				return;
			}

			const email = emailInput.value.trim();
			if ( ! email ) {
				return;
			}

			const errorContainer = form.querySelector('[data-js-back-in-stock-errors]');
			if ( errorContainer ) {
				errorContainer.innerHTML = '';
			}

			if ( ! publicKey ) {
				this._showError(form, this._getGenericErrorMessage());
				return;
			}

			if ( ! variantId ) {
				this._showError(form, this._getGenericErrorMessage());
				return;
			}

			submitButton.classList.add(`${this._prefix}working`);

			try {
				await this._updateProfileLocale(email, form, publicKey);

				const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(publicKey)}`;
				const response = await fetch(url, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						revision
					},
					body: JSON.stringify(this._buildPayload(email, variantId, catalogId))
				});

				if ( response.status === 202 ) {
					this._showSuccess(form);
					return;
				}

				let data = null;
				const text = await response.text();
				if ( text ) {
					try {
						data = JSON.parse(text);
					} catch (error) {
						data = null;
					}
				}

				this._showError(form, this._parseKlaviyoError(data, response));
			} catch (error) {
				console.error(error);
				this._showError(form, error?.message || this._getGenericErrorMessage());
			} finally {
				submitButton.classList.remove(`${this._prefix}working`);
			}
		}
	};

	if ( document.readyState === 'loading' ) {
		document.addEventListener('DOMContentLoaded', () => {
			window.BackInStockForm.init();
		});
	} else {
		window.BackInStockForm.init();
	}

}
